import * as yup from 'yup';

export const fanProfileSchema = yup.object().shape({
  fullName: yup.string().required('Please enter your full name'),
});
